import React from 'react';
import { useDispatch } from 'react-redux';
import { refreshDatasource } from 'core/actions';
import { RefreshIcon } from 'components';

const DatasourceRefresh = () => {
	const dispatch = useDispatch();

	return (
		<RefreshIcon
			aria-label='Recargar datos'
			onClick={() => dispatch(refreshDatasource())}
		/>
	);
};

export default DatasourceRefresh;
